const YOUTUBE_ID = /^[A-Za-z0-9_-]{6,}$/;
const VIMEO_ID = /^\d+$/;

/**
 * Convert the allow-listed YouTube and Vimeo URL forms into an embeddable URL.
 * Returning null is also the validation signal used by the teaching-tile API.
 */
export function allowedVideoEmbedUrl(
  value: string | null | undefined,
): string | null {
  if (!value) return null;

  let url: URL;
  try {
    url = new URL(value);
  } catch {
    return null;
  }

  if (
    url.protocol !== "https:" ||
    url.username ||
    url.password ||
    url.port ||
    url.hash
  ) {
    return null;
  }

  let videoId: string | null = null;
  if (url.hostname === "www.youtube.com" && url.pathname === "/watch") {
    videoId = url.searchParams.get("v");
  } else if (url.hostname === "www.youtube.com") {
    const match = url.pathname.match(/^\/embed\/([^/]+)\/?$/);
    videoId = match?.[1] ?? null;
  } else if (url.hostname === "youtu.be") {
    const match = url.pathname.match(/^\/([^/]+)\/?$/);
    videoId = match?.[1] ?? null;
  }

  if (videoId && YOUTUBE_ID.test(videoId)) {
    return `https://www.youtube.com/embed/${videoId}`;
  }

  if (url.hostname === "vimeo.com") {
    const match = url.pathname.match(/^\/(\d+)\/?$/);
    videoId = match?.[1] ?? null;
  } else if (url.hostname === "player.vimeo.com") {
    const match = url.pathname.match(/^\/video\/(\d+)\/?$/);
    videoId = match?.[1] ?? null;
  }

  return videoId && VIMEO_ID.test(videoId)
    ? `https://player.vimeo.com/video/${videoId}`
    : null;
}
